import React, { createContext, useContext, useState, useEffect } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window !== "undefined") {
      // Check for existing preferences (support both old and new keys)
      const savedTheme = localStorage.getItem("theme");
      const savedDarkMode = localStorage.getItem("darkMode");

      if (savedTheme !== null) {
        // Migrate old "theme" key to new "darkMode" key
        const prefersDark = savedTheme === "dark";
        localStorage.setItem("darkMode", prefersDark);
        localStorage.removeItem("theme");

        // Apply immediately to avoid flash
        if (prefersDark) {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
        return prefersDark;
      }

      if (savedDarkMode !== null) {
        const prefersDark = savedDarkMode === "true";
        // Apply immediately to avoid flash
        if (prefersDark) {
          document.documentElement.classList.add("dark");
        } else {
          document.documentElement.classList.remove("dark");
        }
        return prefersDark;
      }

      // No saved preference - check system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      if (prefersDark) {
        document.documentElement.classList.add("dark");
      }
      return prefersDark;
    }
    return false;
  });

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("darkMode", isDark);
  }, [isDark]);

  return (
    <ThemeContext.Provider value={{ isDark, setIsDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
